module.exports = new __parcel__URL__("Sales Portal Hover.64b2d259.svg").toString();